import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AlertSubscriptionView } from "./AlertSubscriptionView";
import { AlertSubscriptionViewStore } from "../../store/AlertSubscriptionViewStore";
import { useStore } from "../../../../hooks";

export const AlertSubscriptionViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/alertSubscription/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AlertSubscriptionViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AlertSubscriptionView alertSubscriptionViewStore={store} />
      </PageLayout>
    </div>
  );
});
